/*
Rajesh 11/14/2022 3225736869 Add night jobs New UX.
Ashraf 11/14/2022 3225736869 rendering scheduler for add night jobs
Ashraf 11/15/2022 3225736869 rendering Add Task for add night jobs
Prakash 11/16/2022 3225736869  Added card for StepperComponent.
Prakash 11/18/2022 3225736869  Fixed Button Alignment.
akhila 11/18/2022  3225736869 added tabvalues for Scheduler
Guru Prasad 11/22/2022  3225736869 Table alignment fixes
akhila 11/24/2022 3225736869 implemented animations to completed step
akhila 11/24/2022  3225736869 changed background color for selected step
Lalitha  11/28/2022 3225736869 import SelectTabContextProvider
Dilip 11/28/2022 3225736869 added unsave alert popup
Sai maheshwar 12/04/2022 3225736869 added unsaved changes alert
akhila 12/04/2022 3225736869 changed scheduler imports
Prakash 12/06/2022 3225736869 Imported theme provider for styles.
Poornima 12/07/2022 3225736869 renamed search night jobs
Rohini 12/08/2022 3225736869 spacing issue fix for button.
Lalitha 12/09/2022  3225736869  Added reusable backButtonText
Saikrishna 12/09/2022 3225736869 save and stay in page functionality added.
Ashraf 12/16/2022 3225736869 fixed role based access
kavyareddy 12/28/2022 3225736869 Added download configuration button
Akhila 02/01/2023 3225736869 "printIndivual" added in payload
Akhila 02/08/2023 3225736869 "printIndividual" added in payload
suresh peddavoora 02/21/2023 3225736869 New UI changes
suresh peddavoora 02/22/2023 3225736869 New UI changes

Akhila 02/27/2023 3225736869 implemented preview file functionality in download configuration
Akhila 03/10/2023 3225736869 Added preview toast message and loader
Sohel 03/10/2023 3225736869 added StepIconComponent for showing Numbers in StepLabel

*/

import {
  Button,
  makeStyles,
  Stepper,
  StepLabel,
  Step,
} from '@material-ui/core';
import React, {useState, useEffect, useContext, useRef} from 'react';
import {ArrowBack} from '@material-ui/icons';
import NightJobBasicInfo from './BasicInfo';
import NightJobTaskTable from './Task';
import StepConnector from '@material-ui/core/StepConnector';
import {withStyles} from '@material-ui/core/styles';
import {useDispatch, useSelector} from 'react-redux';
import SelectTabContextProvider from '../../../../../components/SelectTabContext/SelectTabContext';
import useUnsavedChangesWarning from '../../../../../util/CustomHooks';
import {setAlertData} from '../../../../../redux/reducers/UnsavedChangesAlertReducer';
import Scheduler from './../../../Reports/AddReport/StepperComponents/Scheduler';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {backButtonText, downloadButton} from '../../../../../util/Content';
import moment from 'moment';
import {
  postPrintScheduler,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/NightJobs/AddNightJob';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';
import NumberStepIcon from '../../../../../components/customStepIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#056c93',
    },
    '& .MuiStepIcon-active': {
      color: '#056c93',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 'bold',
      },
    },
  },
}));
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);
const AddNightJobs = ({setTabValue, tabValue, edit, handleTabChange, selected}) => {
  const stepperClasses = useStyles();
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const steps = ['Basic Info', 'Add Task', 'Scheduler'];
  const [activeStep, setActiveStep] = React.useState(0);

  const showAlertRef = useRef(false);
  const {routerPrompt, onDirty, onPristine} = useUnsavedChangesWarning();

  const {setSaveTab, setSample, saveTab} =
    useContext(SelectTabContextProvider);
  const {jobDetailsData, configurationUrl, dockey} = useSelector(
    ({addNightJob}) => addNightJob,
  );
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  useEffect(() => {
    if (configurationUrl) {
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
      }
      readData();
    }
  }, [configurationUrl]);
  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
    case 0:
      return (
        <NightJobBasicInfo
          handleBack={handleBack}
          selected={selected}
          activeStep={activeStep}
          handleNext={handleNext}
          edit={edit}
          handleTabChange={handleTabChange}
          setSample={setSample}
          setSaveTab={setSaveTab}
          saveTab={saveTab}
          {...alertProps}
        />
      );
    case 1:
      return (
        <NightJobTaskTable
          handleBack={handleBack}
          selected={selected}
          activeStep={activeStep}
          handleNext={handleNext}
          handleTabChange={handleTabChange}
          setSample={setSample}
          setSaveTab={setSaveTab}
          saveTab={saveTab}
          {...alertProps}
        />
      );
    case 2:
      return (
        <Scheduler
          setSample={setSample}
          {...alertProps}
          selected={selected}
          setSaveTab={setSaveTab}
          saveTab={saveTab}
          setTabValue={setTabValue}
          handleTabChange={handleTabChange}
          handleBack={handleBack}
          setValue={handleNext}
          nightJobsScheduler={true}
        />
      );
    }
  };
  const isCurrentStepperCompleted = jobDetailsData?.taskRequest?.length > 0;
  return (
    <div className={classes.cardStyleWhite}>
      {routerPrompt}
      <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setTabValue(0);
                  },
                }),
              );
            } else {
              setTabValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
        {jobDetailsData?.jobCode && (
          <Button
            type="button"
            variant="outlined"
            className={`search-btn ml-2 ${classes.buttonRoot}`}
            onClick={() => {
              dispatch(
                postPrintScheduler({
                  jobCode: jobDetailsData?.jobCode ? jobDetailsData.jobCode : '',
                  createdFor: jobDetailsData?.createdFor ? jobDetailsData?.createdFor : '',
                  isDraft: jobDetailsData?.isDraft?.key ? jobDetailsData?.isDraft?.key : '',
                  jobName: jobDetailsData?.jobName ? jobDetailsData?.jobName : '',
                  jobDescription: jobDetailsData?.jobDescription ?
                    jobDetailsData.jobDescription :
                    '',
                  jobStatus: jobDetailsData?.jobStatus ? jobDetailsData?.jobStatus : '',
                  nextRuntime: jobDetailsData?.nextRunTime ?
                    moment(jobDetailsData?.nextRunTime).format('MM/DD/YYYY hh:mm:ss') :
                    '',
                  lastRunTime: jobDetailsData?.lastRunTime ?
                    moment(jobDetailsData?.lastRunTime).format('MM/DD/YYYY hh:mm:ss') :
                    '',
                  createdBy: jobDetailsData?.createdBy?.userName ?
                    jobDetailsData?.createdBy?.userName :
                    '',
                  createdDate: jobDetailsData?.createdDate ?
                    moment(jobDetailsData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  orderBy: '',
                  orderDirection: '',
                  limit: '',
                  page: '',
                  printIndividual: 'Y',
                }),
              );
            }}
          >
            {downloadButton}
          </Button>
        )}
      </div>
      <div className={classes.root} style={{border: '1px solid #cfcfcf'}}>
        <Stepper activeStep={activeStep} connector={<QontoConnector />}>
          {steps.map((label, index) => (
            <Step
              key={label}
              completed={isCurrentStepperCompleted || index < activeStep}
              onClick={() => {
                if (jobDetailsData?.taskRequest?.length > 0) {
                  if (showAlertRef.current) {
                    dispatch(
                      setAlertData({
                        showAlert: showAlertRef.current,
                        alertCallback: () => {
                          setActiveStep(index);
                        },
                      }),
                    );
                  } else {
                    setActiveStep(index);
                  }
                }
              }}
              style={{cursor: 'pointer'}}
            >
              <StepLabel
                className={`${stepperClasses.stepperIcon } ${
                  activeStep === index ? 'completedStyle' : null
                }`}
                StepIconComponent={NumberStepIcon}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          <div style={{padding: '1.2rem 0.5rem'}}>
            {getStepContent(activeStep)}
            {/* <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "10px",
              }}
            >
              <Button
                variant="contained"
                disabled={activeStep === 0}
                onClick={handleBack}
                className={`reset-btn mr-1 ${classes.buttonRoot}`}
              >
                Back
              </Button>
              <Button
                variant="contained"
                onClick={handleNext}
                type="submit"
                className={`search-btn ml-1 ${classes.buttonRoot}`}
              >
                {activeStep === steps.length - 1 ? "Finish" : "Save & Next"}
              </Button>
            </div>  */}
          </div>
          {/* )} */}
        </div>
      </div>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Scheduler'}
        name={'Job Name'}
        code={jobDetailsData?.jobCode}
        description={'Job Description'}
        descriptionValue={jobDetailsData?.jobDescription}
      />
    </div>
  );
};

export default AddNightJobs;
